// Import Firebase core and required Firestore functionalities
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, getDocs, getDoc, query, where, doc, updateDoc, orderBy, setDoc, writeBatch } from "firebase/firestore"; 
import { GoogleAuthProvider } from "firebase/auth";

// Optionnel : Analytics si nécessaire
import { getAnalytics } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAnUE_tdj2pAMlqBQe5OUWRYzRQrSEgS4M",
  authDomain: "mendyx-adafe.firebaseapp.com",
  projectId: "mendyx-adafe",
  storageBucket: "mendyx-adafe.firebasestorage.app",
    messagingSenderId: "448278444464",
  appId: "1:448278444464:web:4465f254a1048251693e75",
  measurementId: "G-JWVRXBTLLZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Optionnel : Initialiser Analytics si nécessaire
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Export Firestore functionalities including getDoc
const googleProvider = new GoogleAuthProvider(); // ✅ cette ligne est manquante


// Export Firestore functionalities including getDoc
export { googleProvider,app,db, collection, addDoc, getDocs, getDoc, query, where, doc, updateDoc, orderBy, setDoc, writeBatch };
